// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListTablesResponseContent
 */
export interface ListTablesResponseContent {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListTablesResponseContent
     */
    tables: Array<string>;
}

/**
 * Check if a given object implements the ListTablesResponseContent interface.
 */
export function instanceOfListTablesResponseContent(value: object): value is ListTablesResponseContent {
    if (!('tables' in value) || value['tables'] === undefined) return false;
    return true;
}

export function ListTablesResponseContentFromJSON(json: any): ListTablesResponseContent {
    return ListTablesResponseContentFromJSONTyped(json, false);
}

export function ListTablesResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTablesResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'tables': json['tables'],
    };
}

export function ListTablesResponseContentToJSON(json: any): ListTablesResponseContent {
    return ListTablesResponseContentToJSONTyped(json, false);
}

export function ListTablesResponseContentToJSONTyped(value?: ListTablesResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tables': value['tables'],
    };
}
